import { render, staticRenderFns } from "./financial-summary.vue?vue&type=template&id=80a04b80"
import script from "./financial-summary.vue?vue&type=script&lang=js"
export * from "./financial-summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports